import { useCountry } from "@root/hooks/useCountry";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {
  country: {},
  isLoading: false,
};

const CountryContext = createContext<any>(defaultState);

interface CountryContextProviderProps {
  children: ReactNode;
}

export const CountryProvider: React.FC<CountryContextProviderProps> = ({
  children,
}) => {
  const country = useCountry();
  return (
    <CountryContext.Provider value={country}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountryContext = () => {
  return useContext(CountryContext);
};
